import { Component } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  AccountCreationSteps,
  FinancialAccountsCreationService
} from "@brightside-web/desktop/feature/financial-accounts-core";

@Component({
    selector: 'brightside-web-spending-account-verification',
    templateUrl: './spending-account-verification.component.html',
    styleUrls: ['./spending-account-verification.component.css'],
    standalone: false
})
export class SpendingAccountVerificationComponent {

  productType = 'spending';
  routeOnSuccess = ['../consents'];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private faCreateSvc: FinancialAccountsCreationService
  ) {}

  submitAction() {
    this.faCreateSvc.advanceStep(AccountCreationSteps.VERIFICATION);
    this.router.navigate(this.routeOnSuccess, { relativeTo: this.route });
  }

}
